import React from 'react';
import { EmailBlock, DividerBlockContent } from '../../types';

interface DividerPropertiesProps {
  block: EmailBlock;
  onUpdate: (updates: Partial<DividerBlockContent>) => void;
  mergeTags?: Array<{ name: string; value: string; sample: string }>;
  isDarkMode: boolean;
}

export const DividerProperties: React.FC<DividerPropertiesProps> = ({
  block,
  onUpdate,
  isDarkMode
}) => {
  const content = block.content as DividerBlockContent;

  return (
    <div className="space-y-4">
      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Color
        </label>
        <input
          type="color"
          value={content.color || '#e5e7eb'}
          onChange={(e) => onUpdate({ color: e.target.value })}
          className="w-full h-10 border rounded-md"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Thickness (px)
        </label>
        <input
          type="number"
          value={content.thickness || 1}
          onChange={(e) => onUpdate({ thickness: parseInt(e.target.value) || 1 })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          min="1"
          max="10"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Style
        </label>
        <select
          value={content.style || 'solid'}
          onChange={(e) => onUpdate({ style: e.target.value as any })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
        >
          <option value="solid">Solid</option>
          <option value="dashed">Dashed</option>
          <option value="dotted">Dotted</option>
        </select>
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Spacing
        </label>
        <input
          type="text"
          value={content.spacing || '20px 0'}
          onChange={(e) => onUpdate({ spacing: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="20px 0"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Width
        </label>
        <input
          type="text"
          value={content.width || '100%'}
          onChange={(e) => onUpdate({ width: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="100%"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Alignment
        </label>
        <select
          value={content.align || 'center'}
          onChange={(e) => onUpdate({ align: e.target.value as any })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>
    </div>
  );
};
